import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2656d9be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-2" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "no-staked text-sm text-center"
}
const _hoisted_4 = { class: "flex flex-wrap justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTCard = _resolveComponent("NFTCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.nfts.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.emptyText), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nfts, (nft) => {
        return (_openBlock(), _createBlock(_component_NFTCard, {
          key: nft,
          nft: nft,
          staked: _ctx.staked,
          selectedNFT: _ctx.selectedNFT,
          onSelected: _ctx.handleSelected
        }, null, 8, ["nft", "staked", "selectedNFT", "onSelected"]))
      }), 128))
    ])
  ]))
}